import { createColumnHelper } from "@tanstack/react-table";
import {
  EditActionButton,
  ViewActionButton,
} from "../../../../../../components/common/primebmd-ui/EditActionButton";
import { ESRColumns } from "../utils/types";
import { useAuth } from "../../../../../../components/AuthProvider";

export const useCreateESRUnstartedColumns = () => {
  const currUser = useAuth();
  const hasESRManagementPermission =
    currUser &&
    currUser?.currentUserRole?.permissions.includes("ESR::MANAGEMENT");

  const columnHelper = createColumnHelper<ESRColumns>();

  const esrUnstartedColumns = [
    columnHelper.accessor("esrNumber", {
      id: "esrNumber",
      header: "JO No.",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: false,
    }),
    columnHelper.accessor("equipmentNo", {
      id: "equipmentNo",
      header: "Equipment No.",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("projectLocation", {
      id: "projectLocation",
      header: "Project / Location",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("daysElapsed", {
      id: "daysElapsed",
      header: "Days Elapsed",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    ...(hasESRManagementPermission
      ? [
          columnHelper.display({
            id: "actions",
            header: "Action",
            cell: ({ row }) => (
              <EditActionButton route={`start/${row.original.id}`} />
            ),

            enableHiding: false,
          }),
        ]
      : [
          columnHelper.display({
            id: "actions",
            header: "Action",
            cell: ({ row }) => (
              <ViewActionButton route={`view/${row.original.id}`} />
            ),

            enableHiding: false,
          }),
        ]),
  ];

  return esrUnstartedColumns;
};
